import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20abstract%20geometric%20composition%20with%20soft%20warm%20cream%20beige%20and%20terracotta%20gradients%2C%20smooth%20flowing%20curves%2C%20clean%20modern%20design%2C%20light%20airy%20atmosphere%2C%20subtle%20texture%2C%20zen%20like%20calm%20background%2C%20no%20text%20or%20objects&width=1600&height=900&seq=hero-bg-nana&orientation=landscape"
          alt="娜娜轻量版"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs md:text-sm font-medium text-background-50">娜娜轻量版 v2.0 正式发布</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-6">
          轻盈体验，高效触达
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          专为追求极简高效体验用户打造的轻量化解决方案。体积小、启动快、功能精准，让每一次操作都轻盈流畅。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#download"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            免费下载
            <i className="ri-download-line ml-2"></i>
          </a>
          <Link
            to="/category/all"
            className="px-8 py-3.5 rounded-full border border-background-50/40 text-background-50 font-medium text-sm md:text-base hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap"
          >
            了解更多
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 text-background-50/60">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold font-heading text-background-50">500万+</p>
            <p className="text-xs mt-1">全球用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold font-heading text-background-50">4.9</p>
            <p className="text-xs mt-1">用户评分</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold font-heading text-background-50">&lt;30MB</p>
            <p className="text-xs mt-1">安装体积</p>
          </div>
        </div>
      </div>
    </section>
  );
}